import { useStyle } from "@/context/StyleContext";
import { DiamondOutlined } from "@mui/icons-material";
import { Text } from "../text/Text";

const SectionTitle = ({
  title,
  children,
}: {
  title: string;
  children?: React.ReactNode;
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          columnGap: "20px",
        }}
      >
        <VanishingHorizontalLine fadeInFrom="right" width="150px" />
        <DiamondOutlined style={{ fontSize: 30 }} />
        <VanishingHorizontalLine width="150px" />
      </div>
      <Text type="h2" style={{ marginTop: 6 }}>
        {title}
      </Text>
      <div
        style={{
          flexWrap: "wrap",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default SectionTitle;

const VanishingHorizontalLine = ({
  fadeInFrom = "left",
  width = "100px",
}: {
  fadeInFrom?: "right" | "left";
  width?: string;
}) => {
  const { theme, colors } = useStyle();
  return (
    <div
      style={{
        width: width,
        height: "1px",
        background:
          ` linear-gradient(to ${fadeInFrom}, transparent, ` +
          colors[theme].text +
          ")",
        marginTop: "10px",
        marginBottom: "10px",
      }}
    />
  );
};
